import { SESSION_SCREEN, SessionEventEnum, SessionScreenEnum } from './events';

import { session } from './session';

const eventNavMap: Partial<
  Record<
    SessionEventEnum,
    (typeof SESSION_SCREEN)[keyof typeof SessionScreenEnum]
  >
> = {
  [SessionEventEnum.QUOTE_RECEIVED]: SESSION_SCREEN.REVIEW_QUOTE,
  [SessionEventEnum.QUOTE_ACCEPTED]: SESSION_SCREEN.CUSTOMER_AND_VEHICLE_INFO,
  [SessionEventEnum.QUOTE_REJECTED]: SESSION_SCREEN.REQUEST_QUOTE,
  [SessionEventEnum.QUOTE_BOOKED]: SESSION_SCREEN.SDK_SUMMARY,
  [SessionEventEnum.CUSTOMER_AND_VEHICLE_INFO]: SESSION_SCREEN.PICKUP_INFO,
  [SessionEventEnum.PICKUP_INFO]: SESSION_SCREEN.DELIVERY_INFO,
  [SessionEventEnum.DELIVERY_INFO]: SESSION_SCREEN.PAYMENT_INFO,
  [SessionEventEnum.ORDER_SUCCESS]: SESSION_SCREEN.ORDER_SUCCESS,
  [SessionEventEnum.PAYMENT_FAILURE]: SESSION_SCREEN.PAYMENT_INFO,
  [SessionEventEnum.ORDER_FAILURE]: SESSION_SCREEN.ORDER_FAILURE
};

const buildUrlWithSearchParams = (baseUrl: string): string => {
  const currentUrl = new URL(window.location.href);
  const currentParams = currentUrl.searchParams;

  const params = new URLSearchParams();

  currentParams.forEach((value, key) => {
    if (value) {
      params.append(key, value);
    }
  });

  const queryString = params.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

export const processNextUrl = (event: keyof typeof SessionScreenEnum) => {
  const sdkBrand = session.getSdk();
  const nextScreen = eventNavMap[event as SessionEventEnum];

  if (
    event === (SessionEventEnum.QUOTE_RECEIVED as string) &&
    sdkBrand !== null
  ) {
    const baseUrl = `${window.origin}/sdk${sdkBrand ? `/${sdkBrand}` : ''}/quote`;
    document.location.href = buildUrlWithSearchParams(baseUrl);
  } else if (
    event === (SessionEventEnum.QUOTE_REJECTED as string) ||
    event === (SessionEventEnum.QUOTE_NEW as string)
  ) {
    if (sdkBrand === null) {
      const baseUrl = window.origin;
      document.location.href = buildUrlWithSearchParams(baseUrl);
    } else {
      const baseUrl = `${window.origin}/sdk${sdkBrand ? `/${sdkBrand}` : ''}`;
      document.location.href = buildUrlWithSearchParams(baseUrl);
    }
  } else if (
    event === (SessionEventEnum.QUOTE_BOOKED as string) &&
    sdkBrand !== null
  ) {
    const baseUrl = `${window.origin}/sdk${sdkBrand ? `/${sdkBrand}` : ''}/summary`;
    document.location.href = buildUrlWithSearchParams(baseUrl);
  } else if (nextScreen) {
    const baseUrl = window.origin + nextScreen;
    document.location.href = buildUrlWithSearchParams(baseUrl);
  }
};
